import './clickableSectionList.scss';
import {ClickableElement} from './clickableSectionList';
import classNames from 'clsx';
import {Icons} from '../../../../../icons/icons';
import {useTranslation} from 'react-i18next';
import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import {SvgIcon} from '../../../../../icons/svgIcon';
import {useDispatch} from 'react-redux';
import {resetTransformAction, setScrollTargetAction} from '../../../../duck/search-actions';
import {FacetFilterWidget} from '../../../../../facets/facetFilterWidget';

export const TocRenderer = (clickableElements: ClickableElement[] | null) => {
    const {t} = useTranslation();
    const [expanded, setExpanded] = useState<boolean>(true);
    const [filter, setFilter] = useState('');
    const dispatch = useDispatch();

    if (clickableElements && clickableElements.length === 0) {
        return null;
    }

    const onElementClick = (element: ClickableElement) => {
        dispatch(resetTransformAction(true));
        dispatch(setScrollTargetAction(element));
    };

    return (
        <div>
            <div className={classNames('sections-list-header')}>
                <div onClick={() => setExpanded(!expanded)} className={classNames('sections-list-header-start')}>
                    <Button className="heading-drop-down-button">
                        <SvgIcon icon={Icons.CHEVRON_DOWN}
                                 className={expanded ? 'expanded' : ''}
                        />
                    </Button>
                    <div className={'header-title'}>
                        {t('fieldTitle.tagsPlural.tocHeader.label')}
                    </div>
                </div>
                {expanded && (
                    <FacetFilterWidget filter={filter} setFilter={setFilter}
                                       title={t('fieldTitle.tagsPlural.tocHeader.label')}/>
                )}
            </div>
            {expanded && (<ul className={classNames('sections-list')}>
                {clickableElements?.filter(el => !filter || el.label.toLowerCase().includes(filter.toLowerCase()))
                    .map(element => (
                        <li onClick={() => onElementClick(element)} key={'id_' + element.label}
                            className={classNames('sections-element', 'toc-element')}>
                            {element.label}
                        </li>
                    ))}
            </ul>)}
        </div>
    );
};
